import { RequestState } from '../../../types'
import { AddressSettingsState, initialAddressSettingsState } from '../../address/store/store'
import { CertificateSettingsState } from '../../certificates/store/store'
import { initialCertificateSettingsState } from '../../certificates/store/store'
import { ContactsSettingsState, initialContactsSettingsState } from '../../contacts/store/store'
import { DetailsSettingsState, initialDetailsSettingsState } from '../../details/store/store'

export type SettingsAccount = {
  isPapertrailEmployee: boolean
}

export type RootSettingsState ={
  account?: SettingsAccount
  requestState: RequestState
}

export type SettingsState = {
  details: DetailsSettingsState
  certificates: CertificateSettingsState
  address: AddressSettingsState
  contacts: ContactsSettingsState
}

export const initialSettingsState: SettingsState = {
  details: initialDetailsSettingsState,
  certificates: initialCertificateSettingsState,
  address: initialAddressSettingsState,
  contacts: initialContactsSettingsState
}
